export const TOGGLE = 'Explorer/data/sectionOpenFileExplorer/TOGGLE';

export const toggle = () => ({
  type: TOGGLE,
  payload: null,
})
